export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Орындалуда"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Аяқталды"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Күтілуде"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Келесі"])}
}